module.exports = __webpack_public_path__ + "img/element-3.177a47a5.svg";